import React, { Component, Fragment } from 'react';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import LogInOut from './LogInOut';
import AddAlbum from './AddAlbum';
import { albums, loggedIn, whenLoggedIn, access, addAlbum } from './PhotosRest';

import AlbumEntry from './AlbumEntry';

export default class Photos extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    albums: [],
	    loggedIn: loggedIn(),
	    userlevel: 0,
	    showLogin: false,
	    loginFailed: false,
	    username: '',
	    password: '',
	    showAdd: false,
	    access: [],
	    albumName: '',
	    albumAccess: 0,
	    showAlbum: '',
	    showPicture: '',
	    controlPressed: false
	}
	this.setUrl();
    }

    async componentDidMount() {
	let path = this.props.pathname.split('/');
	if (path.length > 1) {
	    this.setState({
		showAlbum: path[1],
		showPicture: path[2],
	    });
	}
	this.setState({
	    albums: await albums(),
	    access: await access()
	});
	whenLoggedIn(u => this.setState({ userlevel: u.levelId }));
    }

    updateLogin = async () => this.setState({ albums: await albums() });
    toggleLogin = () => {
	this.setState({ showLogin: !this.state.showLogin });
    }

    updateAlbumName = e => this.setState({ albumName: e.target.value });
    updateAlbumAccess = e => this.setState({ albumAccess: e.target.value });

    toggleShowAdd = () => this.setState({ showAdd: !this.state.showAdd });

    addAlbum = (name, access) => {
	whenLoggedIn(async u => {
	    if (u.levelId < 2) { return; }
	    await addAlbum(name, access);
	    this.setState({
		showAdd: false,
		albums: await albums()
	    });
	});
    }

    handleKey = (key, event) => {
	if (key === 'a' || key === 'plus') {
	    this.toggleShowAdd();
	    event.preventDefault();
	    return;
	}
	if (key === 'l') {
	    event.preventDefault();
	    if (loggedIn()) return;
	    this.toggleLogin();
	    return;
	}
    }

    setUrl = () => window.history.pushState({}, '', '/');

    showReset = () => this.setState({ showAlbum: null, showPicture: null });

    render() {
	return (<Fragment>
		<LogInOut showLogin={this.state.showLogin} toggle={this.toggleLogin} parentUpdate={this.updateLogin} />
		{ this.state.userlevel > 1 && <div className='addAlbum' onClick={this.toggleShowAdd}>+</div> }
		{ this.state.showAdd &&
		  <AddAlbum
		  addAlbum={this.addAlbum}
		  toggleShowAdd={this.toggleShowAdd}
		  access={this.state.access}/> }
		{ this.state.albums.length === 0 && <div className='loader'/> }
		{ this.state.albums.map(a => <AlbumEntry parentUrl={this.setUrl} album={a} showAlbum={this.state.showAlbum} showPicture={this.state.showPicture} showReset={this.showReset} key={a.setId}/>) }
		<KeyboardEventHandler
		handleKeys={['a', 'l', 'plus']}
		onKeyEvent={this.handleKey} />
		</Fragment>);
    }
}
